var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"text-center"},[_c('img',{staticStyle:{"margin":"auto"},attrs:{"src":require('@/assets/cox-spin.gif'),"alt":"Chargement en cours..."}})])}
var staticRenderFns = []

export { render, staticRenderFns }